import React, { useState, useEffect } from 'react';
import MainLayout from './mainLayout';
import PointerItem from '../components/pointerItem';
import { useData } from '../hooks/useContext';
import Pagination from '../components/pagination';
import { paginate } from '../utils/paginate';
import Loader from '../components/loader';
import { IPerson, IUseData } from '../interfaces';
import PageCard from '../components/pageCard';
import Search2 from '../components/search2';
import personsService from '../services/persons.service';
import { CONFIG } from '../config';

const PersonsList = () => {
  const { setPage, persons, theme } = useData() as IUseData;
  const [paginationPage, setPaginationPage] = useState<number>(1);
  const [filteredPersons, setFilteredPersons] = useState<IPerson[]>([]);

  const pageSize: number = 16;

  useEffect(() => {
    setPage('persons');
    document.title = CONFIG.PAGES_CARDS.PERSONS_PAGE.HEADER;
  }, []);

  useEffect(() => {
    setFilteredPersons(persons);
  }, [persons]);

  const handleSearchResult = (data: any) => {
    console.log('PersonList.handleSearchResult()', data);

    if (data == null) {
      setFilteredPersons(persons);
    } else {
      let newPers: IPerson[] = [];
      persons.forEach((per: IPerson) => {
        if (data.includes(per._id)) {
          newPers.push(per);
        }
      });
      setFilteredPersons(newPers);
    }
  };

  return (
    <MainLayout>
      {/* <div className="m-auto w-full 2xl:w-4/5 h-100 md:px-12 flex flex-col px-2"> */}
      <PageCard />
      {CONFIG.SHOW_SEARCH2 ? <Search2 onResult={handleSearchResult} searchFunction={personsService.search2} /> : null}
      <main className={'grow flex flex-col rounded-[40px] p-[40px] my-5' + theme.active}>
        {filteredPersons ? (
          <>
            <h2 className={'text-2xl font-medium mb-2 border-b-2' + theme.redBorder} autoFocus={true}>
              {'Люди (' + filteredPersons.length + ')'}
            </h2>
            <ul>
              {paginate<IPerson>(filteredPersons, paginationPage, pageSize).map((item: IPerson) => (
                <PointerItem
                  key={item._id}
                  name={item.name}
                  link={'persons/' + item._id}
                  num={filteredPersons.indexOf(item) + 1}
                />
              ))}
            </ul>
            <Pagination
              productCount={filteredPersons.length}
              pageSize={pageSize}
              currentPage={paginationPage}
              onPageChange={(page: number) => setPaginationPage(page)}
            />
          </>
        ) : (
          <Loader title={'Загрузка списка людей...'} />
        )}
      </main>
      {/* </div> */}
    </MainLayout>
  );
};

export default PersonsList;
